module.exports = __webpack_public_path__ + "static/LinkedIn-Prospection-Action-Flow-bc3bfb89a463928c2a981ff4773ace19.jpg";